module.exports = __webpack_public_path__ + "img/f.e2c5b3fe.jpg";